import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_TABLE_LIST } from './url-constants';

type ReportTableListEndpointSpecification = ApiEndpointSpecification;
export const ReportTableListEndpointSpecification: ReportTableListEndpointSpecification = {
    url: DEVICE_TABLE_LIST,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'DeviceReportTableListRequestParams',
    requestBodySchemaName: 'DeviceReportTableListRequestBody',
    okResponseSchemaName: 'DeviceReportTableListOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:2,
};

export const invokeTableReportList = Helpers.makeApiRequestFn<
    Types.ReportTableListRequestParams,
    Types.ReportTableListRequestBody,
    Types.ReportTableListOkresponse
>(ReportTableListEndpointSpecification);
